import React, { useEffect, useState } from 'react';
import { HuchaValues } from '../models/hucha-values';
import { PortalContext } from '../../../../context/PortalContext';
import { formatOwnership } from '../../../../tracking/trackingHelper';
import { useTrackingManager } from '../../../../tracking/useTrackingManager';
import { handleGeneratePDF, pdfDownloaded } from '../../../../helpers/pdf-generator';

const getHuchaPdfFilename = (huchaValues: HuchaValues | null): string => {
	const discountType = huchaValues?.isRenovador ? 'Renovadores' : 'Hucha';
	return `Club Volkwagen - ${discountType} - ${huchaValues?.idUser}.pdf`;
};

// hook para generar el PDF y manejar su estado
export const useHuchaPdfGenerator = (
	huchaValues: HuchaValues | null,
	externalRef?: React.RefObject<HTMLDivElement>,
) => {
	const internalRef = React.useRef<HTMLDivElement>(null); // ref interno si no se pasa uno
	const targetRefPDF = externalRef || internalRef;

	const { portalService } = React.useContext(PortalContext);
	const trackingManager = useTrackingManager();
	const userVehicles = portalService.getPersonVehicles().getValue();

	const [isPdfReady, setIsPdfReady] = useState(false);

	// sincronizar el estado local con el BehaviorSubject
	const [isDownloading, setIsDownloading] = useState(pdfDownloaded.getValue());

	// suscripción al Subject para que el booleano sea reactivo
	useEffect(() => {
		const subscription = pdfDownloaded.subscribe((value) => {
			setIsDownloading(value);
		});
		return () => subscription.unsubscribe();
	}, []);

	const generatePdf = async () => {
		handleGeneratePDF(targetRefPDF, setIsPdfReady, getHuchaPdfFilename(huchaValues));
	};

	// click de descarga
	const handlePdfDownloadClick = () => {
		if (isDownloading) return;
		trackingManager.trackClubVWDownloadClick(
			'Descargar PDF Hucha',
			{ contentId: 'PDF Download bonus hucha' },
			{ vehicle: formatOwnership(userVehicles?.vehicles) },
		);
		generatePdf();
	};

	return { handlePdfDownloadClick, isDownloading, isPdfReady };
};
